import React, { useEffect, useState } from "react";
import { PageContainer, PageHeader, Card, ConfirmDelete } from "./Shared";
import { adminApi } from "./api";
import { Button } from "../components/ui/button";
import { Trash, EnvelopeOpen, Briefcase } from "@phosphor-icons/react";
import { toast } from "sonner";

export default function LeadsManager() {
  const [tab, setTab] = useState("contacts");
  const [contacts, setContacts] = useState([]);
  const [careers, setCareers] = useState([]);

  const loadAll = async () => {
    const [c, j] = await Promise.all([
      adminApi.get("/admin/leads/contacts"),
      adminApi.get("/admin/leads/careers"),
    ]);
    setContacts(c.data);
    setCareers(j.data);
  };
  useEffect(() => { loadAll(); }, []);

  const delContact = async (id) => {
    await adminApi.delete(`/admin/leads/contacts/${id}`); await loadAll(); toast.success("Deleted");
  };
  const delCareer = async (id) => {
    await adminApi.delete(`/admin/leads/careers/${id}`); await loadAll(); toast.success("Deleted");
  };

  return (
    <PageContainer>
      <PageHeader title="Leads" subtitle="Contact form messages and career applications." />
      <div className="flex gap-1 mb-4 border-b border-slate-200">
        {[
          ["contacts", "Contact", contacts.length, EnvelopeOpen],
          ["careers", "Careers", careers.length, Briefcase],
        ].map(([id, label, count, Icon]) => {
          const active = tab === id;
          return (
            <button key={id} onClick={() => setTab(id)} data-testid={`leads-tab-${id}`}
              className="relative px-4 py-2.5 text-[13.5px] font-medium transition flex items-center gap-2"
              style={{ color: active ? "#1B6FE0" : "#6B7A8D" }}>
              <Icon size={14} weight="duotone"/> {label}
              <span className={`text-[11px] px-1.5 rounded-full ${active ? "bg-blue-100" : "bg-slate-100"}`}>{count}</span>
              {active && <span className="absolute inset-x-2 -bottom-px h-0.5 rounded-full" style={{ background: "#1B6FE0" }} />}
            </button>
          );
        })}
      </div>

      {tab === "contacts" && (
        <Card>
          <ul className="divide-y divide-slate-100" data-testid="contact-leads">
            {contacts.length === 0 && <li className="p-8 text-center text-[#6B7A8D]">No leads yet.</li>}
            {contacts.map((c) => (
              <li key={c.id} className="p-5" data-testid={`contact-${c.id}`}>
                <div className="flex items-center justify-between gap-3">
                  <div>
                    <div className="font-semibold text-[14.5px]" style={{ color: "#0F2A6E" }}>{c.name}</div>
                    <div className="text-[12px] text-[#6B7A8D]"><a href={`mailto:${c.email}`} className="hover:underline">{c.email}</a> · {c.phone || "—"} · {c.subject || "no subject"}</div>
                  </div>
                  <div className="flex items-center gap-2">
                    <span className="text-[11px] text-[#94A3B8]">{new Date(c.created_at).toLocaleString()}</span>
                    <ConfirmDelete title="Delete this contact lead?" description={`Message from ${c.name} will be permanently removed.`} onConfirm={() => delContact(c.id)} testId={`contact-del-${c.id}`}>
                      <Button variant="outline" size="sm" className="text-[#1B6FE0] hover:bg-blue-50 hover:text-[#1B6FE0]" data-testid={`contact-del-${c.id}`}><Trash size={13} weight="bold"/></Button>
                    </ConfirmDelete>
                  </div>
                </div>
                {c.message && <p className="mt-2 text-[13.5px] text-[#1C2B3A] leading-relaxed whitespace-pre-wrap">{c.message}</p>}
              </li>
            ))}
          </ul>
        </Card>
      )}

      {tab === "careers" && (
        <Card>
          <ul className="divide-y divide-slate-100" data-testid="career-leads">
            {careers.length === 0 && <li className="p-8 text-center text-[#6B7A8D]">No applications yet.</li>}
            {careers.map((c) => (
              <li key={c.id} className="p-5" data-testid={`career-${c.id}`}>
                <div className="flex items-center justify-between gap-3">
                  <div>
                    <div className="font-semibold text-[14.5px]" style={{ color: "#0F2A6E" }}>{c.full_name} <span className="text-[#6B7A8D] font-normal">— {c.position}</span></div>
                    <div className="text-[12px] text-[#6B7A8D]"><a href={`mailto:${c.email}`} className="hover:underline">{c.email}</a> · {c.phone || "—"} · {c.experience || "—"} years</div>
                  </div>
                  <div className="flex items-center gap-2">
                    <span className="text-[11px] text-[#94A3B8]">{new Date(c.created_at).toLocaleString()}</span>
                    <ConfirmDelete title="Delete this application?" description={`${c.full_name}'s application for ${c.position} will be permanently removed.`} onConfirm={() => delCareer(c.id)} testId={`career-del-${c.id}`}>
                      <Button variant="outline" size="sm" className="text-[#1B6FE0] hover:bg-blue-50 hover:text-[#1B6FE0]" data-testid={`career-del-${c.id}`}><Trash size={13} weight="bold"/></Button>
                    </ConfirmDelete>
                  </div>
                </div>
                {c.cover_letter && <p className="mt-2 text-[13.5px] text-[#1C2B3A] leading-relaxed whitespace-pre-wrap">{c.cover_letter}</p>}
              </li>
            ))}
          </ul>
        </Card>
      )}
    </PageContainer>
  );
}
